export default {
    HIPERTENSAO_COM_COMPLICACOES: 268,
    TOXEMIA_GRAVIDICA_DHEG: 598,
}